<template>
  <div class="pt16">
    <!-- information 隐藏字段用于整体非空校验 -->
    <el-form-item label="" prop="information" ref="information">
      <!-- 表头 -->
      <el-row class="tableHead" :gutter="0">
        <el-col :span="3">
          <div class="enbr">{{ $t("enroll.intitle.theFundsName") }}</div>
        </el-col>
        <el-col :span="3">
          <div class="enbr">{{ $t("enroll.intitle.stock") }}</div>
        </el-col>
        <el-col :span="2">
          <div class="enbr">{{ $t("enroll.intitle.ratio") }}</div>
        </el-col>
        <el-col :span="4" class="enbr">
          <div class="enbr">{{ $t("enroll.intitle.capital") }}</div>
        </el-col>
        <el-col :span="4">
          <div class="enbr">{{ $t("enroll.intitle.paidInCapital") }}</div>
        </el-col>
        <el-col :span="3">
          <div class="enbr">{{ $t("enroll.intitle.hold") }}</div>
        </el-col>
        <el-col :span="4">
          <div class="enbr">{{ $t("enroll.intitle.trust") }}</div>
        </el-col>
      </el-row>
      <!-- 数据行 -->
      <el-row class="tableItem" v-for="(item, index) of innerForm.sharesInfo" :key="index" :gutter="10">
        <!-- 关联基金名称 -->
        <el-col :span="3">
          <el-form-item :prop="`sharesInfo[${index}].fundsName`" :rules="[{ required: true, message: $t('common.placeholder.select'), trigger: 'submit' }]">
            <el-select v-model="item.fundsName" :placeholder="$t('common.placeholder.select')" class="wdb100">
              <el-option v-for="(fund, fidx) in fundInfoList" :key="`fundOpt-${index}-${fidx}`" :label="fund.fundName" :value="fund.fundName"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 股票类型 -->
        <el-col :span="3">
          <el-select v-model="item.typeOfShares" :placeholder="$t('common.placeholder.select')" class="wdb100">
            <el-option v-for="sItem in globalFormatList('stockList')" :key="`stock-${index}-${sItem.value}`" :label="sItem.label" :value="sItem.value"></el-option>
          </el-select>
        </el-col>
        <!-- 所占股份数量 -->
        <el-col :span="2">
          <el-form-item :prop="`sharesInfo[${index}].quantityOfSharesAllotted`" :rules="[{ required: true, message: $t('common.placeholder.enter'), trigger: 'submit' }]">
            <el-input v-model="item.quantityOfSharesAllotted" v-positiveInteger :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <!-- 注册资本 -->
        <el-col :span="4">
          <el-form-item :prop="`sharesInfo[${index}].amountOfPaidUpShareCapital`" :rules="[{ required: true, validator: validateCurrencyAmount, trigger: 'submit' }]">
            <currency-amount v-model="item.amountOfPaidUpShareCapital" class="wdb100" />
          </el-form-item>
        </el-col>
        <!-- 实收资本 -->
        <el-col :span="4">
          <el-form-item :prop="`sharesInfo[${index}].amountOfPaidInShareCapital`" :rules="[{ required: true, validator: validateCurrencyAmount, trigger: 'submit' }]">
            <currency-amount v-model="item.amountOfPaidInShareCapital" class="wdb100" />
          </el-form-item>
        </el-col>
        <!-- 以信托方式持有股份 -->
        <el-col :span="3">
          <div class="wdb100 tac holdWrap">
            <el-radio-group v-model="item.sharesHoldInTrust">
              <el-radio :label="1">{{ $t("common.yes") }}</el-radio>
              <el-radio :label="0">{{ $t("common.no") }}</el-radio>
            </el-radio-group>
          </div>
        </el-col>
        <!-- 信托名称（若适用）- 条件必填（当"以信托方式持有股份"选中"是"时必填） -->
        <el-col :span="4" class="customElCol">
          <el-form-item
            :prop="`sharesInfo[${index}].nameOfTheTrust`"
            :rules="item.sharesHoldInTrust ? [{ required: true, message: $t('common.placeholder.enter'), trigger: 'submit' }] : []"
          >
            <el-input v-model="item.nameOfTheTrust" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1" v-if="!isReadonly">
          <el-button type="text" icon="red fs22 el-icon-delete" @click="handleDelete(index)"></el-button>
        </el-col>
      </el-row>
    </el-form-item>
    <div class="fxRow addCompanyWrap" v-if="!isReadonly">
      <el-button type="text" class="fxVer" @click="handleAdd">
        <span class="fs18 vam el-icon-circle-plus-outline"></span>
        <span class="vam ml0">{{ $t("common.button.addMore") }}</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import validatorMixin from "@/mixins/validatorMixin";
import { mapGetters, mapState } from "vuex";

export default {
  name: "FundDirectorSharesTable",
  mixins: [validatorMixin],
  model: { prop: "value", event: "input" },
  props: {
    value: { type: Object, required: true },
    fundInfoList: { type: Array, default: () => [] },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("constant", ["globalFormatList"]),
    ...mapState("constant", ["currencyList"]),
    innerForm() {
      return this.value;
    },
  },
  methods: {
    /** 同步数据到父组件 */
    emitInput(updatedValue) {
      this.$emit("input", updatedValue || this.value);
    },
    /** 添加一条股份记录 */
    handleAdd() {
      const stockList = this.globalFormatList("stockList");
      const defaultStock = stockList && stockList.length > 0 ? stockList[0].value : "";
      const defaultCurrency = this.currencyList && this.currencyList.length > 0 ? this.currencyList[0].value : "";
      // 默认选中第一个关联基金
      const funds = this.fundInfoList;
      const defaultFundName = funds.length > 0 ? funds[0].fundName : "";

      const newItem = {
        fundsName: defaultFundName,
        typeOfShares: defaultStock,
        quantityOfSharesAllotted: null,
        amountOfPaidUpShareCapital: "",
        amountOfPaidInShareCapital: `${defaultCurrency} 1`,
        sharesHoldInTrust: 0,
        nameOfTheTrust: null,
      };
      const updated = JSON.parse(JSON.stringify(this.value));
      updated.sharesInfo.push(newItem);
      this.emitInput(updated);
    },
    /** 删除一条股份记录 */
    handleDelete(index) {
      const updated = JSON.parse(JSON.stringify(this.value));
      updated.sharesInfo.splice(index, 1);
      this.emitInput(updated);
    },
  },
};
</script>

<style lang="scss" scoped>
.tableHead {
  background: #f4f8fe;
  text-align: center;
  color: #011a45;
  font-weight: bold;
  height: 50px;

  .el-col {
    height: 100%;

    div {
      font-size: 13px;
      line-height: 16px;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
}
.tableItem {
  border-bottom: 1px solid #ebeef5;

  .el-col {
    display: flex;
    align-items: center;
    height: 70px;

    ::v-deep {
      .el-form-item {
        margin-bottom: 0px !important;
      }

      .el-form-item__error {
        padding-top: 2px !important;
      }
    }
  }

  .customElCol {
    ::v-deep {
      .el-form-item {
        .el-input {
          input {
            border-color: #dcdfe6 !important;
          }
        }
      }

      .el-form-item.el-form-item.is-error {
        .el-input {
          input {
            border-color: #f56c6c !important;
          }
        }
      }
    }
  }
}

.holdWrap {
  border: 1px solid #dcdfe6;
}

.addCompanyWrap {
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin-top: 20px;
}
</style>
